<template>
    <mm-select :options="options"
    v-bind="$attrs" :value="value" v-on="$listeners" />
</template>

<script>
export default {
	data(){
		const options = ['global','daily','hourly'].map(v => {
			return { value: v, label: v.substr(0,1).toUpperCase()+v.substring(1)+' Model' };
		});
		return{
			options,
		}
	},
	props:['value'],
}
</script>

